import React, { memo } from 'react'
import tw from 'twin.macro'
import { Chip } from 'src/components/shared/Chip'
import { webhookDeliveryStatusLabels } from 'src/constants/webhook/constants'
import { WebhookDeliveryStatus } from 'src/constants/webhook/enums'

interface Props {
  deliveryStatus: WebhookDeliveryStatus
}

const STATUS_STYLES: Record<WebhookDeliveryStatus, { container: any; text: any }> = {
  [WebhookDeliveryStatus.Success]: {
    container: tw`bg-success-200`,
    text: tw`text-success-500`,
  },
  [WebhookDeliveryStatus.Pending]: {
    container: tw`bg-warning-100`,
    text: tw`text-warning-500`,
  },
  [WebhookDeliveryStatus.Failed]: {
    container: tw`bg-critical-100`,
    text: tw`text-critical-500`,
  },
}

const WebhookDeliveryResultCellComponent = ({ deliveryStatus }: Props) => {
  const styles = STATUS_STYLES[deliveryStatus]

  if (!styles) {
    // An unknown status is shown verbatim rather than mislabelled as one of the three.
    return <Chip text={deliveryStatus} />
  }

  return (
    <Chip
      text={webhookDeliveryStatusLabels[deliveryStatus]}
      className={styles.container}
      textClassName={styles.text}
      dataTestId={`webhook-delivery-status-${deliveryStatus}`}
    />
  )
}

export const WebhookDeliveryResultCell = memo(WebhookDeliveryResultCellComponent)
